import { BlockToolsGroup } from './types';

const activeStateCommands = [
  'bold',
  'italic',
  'underline',
  'link',
  'strikethrough',
  'numberedList',
  'bulletedList',
  'code',
  'emoji',
];

const wrappedTools = [
  BlockToolsGroup.InsertBlockElsKey,
  BlockToolsGroup.InsertPrivateSectionKey,
  BlockToolsGroup.ChangeAlignmentKey,
  BlockToolsGroup.Emoji,
];

export const checkActiveState = (command: string): boolean =>
  new Set(activeStateCommands).has(command);

export const checkDefaultEnabled = (command: string): boolean =>
  new Set(wrappedTools).has(command as BlockToolsGroup);
